export const styles = {
	outerContainer: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '3rem',
		flexGrow: 1,
	},
	innerContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	instructionContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		'@media (max-width: 600px)': {
			flexWrap: 'noWrap',
		},
	},
	instructionText: {
		opacity: '87%',
		width: '86%',
		color: 'black',
	},
	businessComparisonButton: (isSelected: boolean) => ({
		'&&': {
			height: 'unset',
			minHeight: 0,
		},
		color: 'rgba(0, 0, 0, 0.87)',
		fontWeight: 'bold',
		textTransform: 'capitalize',
		backgroundColor: isSelected ? '#CCECB7' : 'none',
		'&:hover': {
			backgroundColor: isSelected ? '#CCECB7' : 'none',
		},
		borderRadius: '4px',
		border: '1px solid var(--light-other-outlined-border-23-p, #0000003B)',
		width: 'auto',
		padding: '16px 32px',
		fontSize: '16px',
		lineHeight: '1.5',
		letterSpacing: '0.15px',
	}),
}
